var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-breadcrumb',{attrs:{"menu":[{label: '客户应收质押登记详情'}]}}),_vm._v(" "),_c('div',[_c('pledge-detail-component',{attrs:{"data":_vm.detailData,"contractData":_vm.contractData}})],1),_vm._v(" "),_c('button-back')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e72fdb96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/lender/ServiceAdmin/PledgeDetail.vue
// module id = null
// module chunks = 